import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { VendorReturnDetailBus } from "./VendorReturnDetailBus";
import { CommonFunctions } from "../static/common-functions";

export class SecJobRolesBus extends BaseBus
 {
     constructor(busObj: BaseBus = null) {
         super(busObj);
         this.insertDt = DateFunctions.getDate(this.insertDt);
         this.updateDt = DateFunctions.getDate(this.updateDt);

     }

     CID(): any {
         return this.secJobRoleId;
     }
     setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
         if (!DateFunctions.isValidDate(this.insertDt)) {
             this.insertDt = date;
             this.insertUserId = userId;
         }
         this.updateDt = date;
         this.updateUserId = userId;
     }
    setFromForm(data: SecJobRolesBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        this.updateDt = dateNow;
        this.updateUserId = data.insertUserId;
        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }

    secJobRoleId: any;
    companyId: any;
    secJobRole: string;
    secJobRoleDesc: string;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
}
